import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaReviewService } from 'src/app/Services/ba-review.service';

@Component({
  selector: 'ze-busniess-review',
  templateUrl: './busniess-review.component.html',
  styleUrls: ['./busniess-review.component.scss']
})
export class BusniessReviewComponent implements OnInit {

  @Input("reportId") reportId: string;

  artifactTypes: string[] = ['suite', 'feature', 'scenario'];
  selectedArtifactType: string = 'suite';
  artifactItems: string[] = [];
  selectedItem: any;
  artifactNames : any ;
  reviewComment: string = '';
  reviewHistory: string[] = [];

  constructor(private baservice : BaReviewService) { }

  ngOnInit(): void {
    this.loadReviewHistory();
    this.getArtifactListPresentInExecution();
  }

  onArtifactChange() {

    if (this.selectedArtifactType) {
      this.getArtifactListPresentInExecution();
    } else {
      this.artifactNames = []; // Clear the data if user resets selection
    }
  }

  public getArtifactListPresentInExecution() {
    const executionId = this.reportId;
    let artifactType = this.selectedArtifactType;
    // console.log('execution id and artifact type ', executionId , artifactType )
    this.baservice.getArtifactListPresentInExecution(executionId, artifactType).subscribe((response: any) => {
      if (response && response.operationStatus === 'SUCCESS') {
        let artifacts = [];

        if (
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0 &&
          response.data[0] != null &&
          response.data[0].artifacts
        ) {
          artifacts = response.data[0].artifacts;
        } else {
          artifacts = [];
        }

        this.artifactNames = artifacts;
        if (artifactType === 'suite' && this.artifactNames && this.artifactNames.length > 0) {
          this.selectedItem = this.artifactNames[0]; // Select first
        } else {
          this.selectedItem = '';
        }
      } else {
        this.artifactNames = [];
        // console.error('Failed to fetch artifacts');
      }
    });
  }

  submitReview(): void {
    if (this.selectedArtifactType && this.selectedItem && this.reviewComment.trim()) {
      const artifactType = this.selectedArtifactType;
      const artifactId = this.selectedItem._id;
      const artifactName = this.selectedItem.name;
      const reviewComment = this.reviewComment.trim();
      const executionId = this.reportId;
      // Call the API to submit review
      this.baservice.submitBusinessReview(executionId ,artifactType, artifactId, artifactName, reviewComment)
        .subscribe(
          (res: any) => {
            // console.log('Review submitted successfully', res);
            const formattedReview = `${artifactType} - ${artifactName}: ${reviewComment}`;
            this.reviewHistory.unshift(formattedReview); // Add to local review history
            this.reviewComment = ''; // Clear textarea
            //again rerendering the reviews history
            this.loadReviewHistory();
          },
          (error) => {
            // console.error('Error submitting review', error);
            alert('Failed to submit review. Try again.');
          }
        );
    } else {
      alert('Please select artifact type, item, and enter a review.');
    }
  }
  
  loadReviewHistory() {
    const executionId = this.reportId;
    // console.log('ExecutionId to fetch history:', executionId);
    this.baservice.reportReviews(executionId).subscribe((response: any) => {
      if (response.operationStatus === 'SUCCESS' && response.data.length > 0) {
        this.reviewHistory = response.data.map(item => ({
          comment: item.review_comment,
          user: item.created_by,
          time: new Date(item.created_time).toLocaleString(),
          artifact_type : item.artifact_type,
          artifact_name : item.artifact_name
        }));
      } else {
        this.reviewHistory = [];
      }
    });
  }
}
